import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Flex } from 'shared/ui'
import { labelObjFor } from 'util/recipientLabel'

const truncate = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Recipient = ({ className, recipient }) => {
  if (!recipient) return null
  const { name, email } = labelObjFor(recipient)

  return (
    <Flex className={className}>
      <div css={truncate} className="name">
        {name}
      </div>
      {email && <div css={truncate} className="email">{`<${email}>`}</div>}
    </Flex>
  )
}

export default styled(Recipient)`
  .email {
    color: ${props => props.theme.color.monochrome.superDark};
    font-size: ${props => props.theme.fontSize.small};
    font-weight: ${props =>
      props.theme.fontWeight.normal} !important; /* SUI override */
    margin-left: ${props => props.theme.spacing['3']};
  }
`
